import { render } from "./PaywallDash.vue?vue&type=template&id=bc8121c6&scoped=true"
import script from "./PaywallDash.vue?vue&type=script&lang=js"
export * from "./PaywallDash.vue?vue&type=script&lang=js"

import "./PaywallDash.vue?vue&type=style&index=0&id=bc8121c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc8121c6"],['__file',"src/views/Paywall/PaywallDash.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc8121c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc8121c6', __exports__)) {
    api.reload('bc8121c6', __exports__)
  }
  
  module.hot.accept("./PaywallDash.vue?vue&type=template&id=bc8121c6&scoped=true", () => {
    api.rerender('bc8121c6', render)
  })

}


export default __exports__